module.exports = __webpack_public_path__ + "static/media/558GriffinStNW_2018-06-05_23.9f05ea9b.jpg";